import React from 'react'
import { useOutletContext } from 'react-router'

import {
  useGetPostRepliesWithTokenQuery,
  useGetMorePostRepliesMutation,
} from '../../services/apiSlice'
import { CurrentUser } from '../../services/schema/User'
import ReplyCard from './ReplyCard'

interface Props {
  postId: string
}

const ReplyByPost: React.FC<Props> = ({ postId }) => {
  const user = useOutletContext<CurrentUser>()
  const [getMorePostReplies] = useGetMorePostRepliesMutation()

  const { data } = useGetPostRepliesWithTokenQuery({
    postId: postId,
  })

  if (data && data.replies.length > 0) {
    const replies = data.replies.map((reply) => {
      return (
        <ReplyCard
          key={reply.replyId}
          data={reply}
          canBeDeleted={reply.replierUserName === user.username}
        />
      )
    })

    return (
      <div>
        {data.replies.length > 0 && replies}
        {data?.nextPage && (
          <article className="hover-sub h-[80px] w-full">
            <button
              type="button"
              onClick={() => {
                getMorePostReplies({
                  page: data.nextPageCount,
                  postId: postId,
                })
              }}
              className="text-blue h-full w-full cursor-pointer font-bold"
            >
              Load older replies?
            </button>
          </article>
        )}
      </div>
    )
  }
}

export default ReplyByPost
